/** Compile-time feature flags resolved from app config during Vite build. */
export const BUILD_FEATURES = {
  video: __FEATURE_VIDEO__,
  epubReader: __FEATURE_EPUB_READER__,
  pdfReader: __FEATURE_PDF_READER__,
  player: __FEATURE_PLAYER__,
} as const
